import StarRate from './StarRate'

export default StarRate
